import React from 'react';
import { FileText, CheckCircle, AlertCircle, Users, Scale, RefreshCw } from 'lucide-react';
import './TermsConditions.css';

const TermsConditions = () => {
  const sections = [
    {
      icon: <CheckCircle size={28} />,
      title: 'سروس کی قبولیت',
      content: `عمل ایپ ڈاؤن لوڈ اور استعمال کرنے سے آپ ان شرائط سے اتفاق کرتے ہیں:

• آپ 13 سال یا اس سے زیادہ عمر کے ہیں
• آپ یہ ایپ قانونی مقاصد کے لیے استعمال کریں گے
• آپ دوسروں کی پرائیویسی کا احترام کریں گے
• آپ غیر قانونی سرگرمیوں میں شامل نہیں ہوں گے
• آپ ہماری کمیونٹی گائیڈلائنز کی پابندی کریں گے`
    },
    {
      icon: <Users size={28} />,
      title: 'صارف کا اکاؤنٹ',
      content: `آپ کے اکاؤنٹ کے حوالے سے درج ذیل شرائط لاگو ہیں:

• آپ صحیح اور درست معلومات فراہم کریں گے
• آپ اپنے پاس ورڈ کو محفوظ رکھیں گے
• آپ اپنے اکاؤنٹ کی سرگرمیوں کے ذمہ دار ہیں
• آپ اپنا اکاؤنٹ کسی کو منتقل نہیں کر سکتے
• غیر فعال اکاؤنٹس حذف کیے جا سکتے ہیں`
    },
    {
      icon: <AlertCircle size={28} />,
      title: 'ممنوعہ سرگرمیاں',
      content: `عمل ایپ استعمال کرتے وقت درج ذیل سرگرمیاں ممنوع ہیں:

• نقصان دہ یا گمراہ کن مواد شیئر کرنا
• دوسروں کو ہراساں کرنا یا دھمکانا
• ایپ کی سیکیورٹی کو نقصان پہنچانا
• غیر مجاز رسائی کی کوشش کرنا
• کاپی رائٹ مواد کی خلاف ورزی کرنا
• جھوٹی معلومات پھیلانا`
    },
    {
      icon: <Scale size={28} />,
      title: 'ذمہ داری کی حدود',
      content: `عمل ایپ کی ذمہ داری کی حدود درج ذیل ہیں:

• ایپ "جیسی ہے" بنیاد پر فراہم کی جاتی ہے
• ہم مسلسل دستیابی کی ضمانت نہیں دیتے
• تکنیکی مسائل پیش آ سکتے ہیں
• مواد میں تبدیلی ہو سکتی ہے
• براہ راست یا بالواسطہ نقصانات کی ذمہ داری نہیں
• صارف اپنے اعمال کے ذمہ دار ہیں`
    },
    {
      icon: <FileText size={28} />,
      title: 'مواد اور کاپی رائٹ',
      content: `عمل ایپ کے مواد کے حوالے سے:

• تمام مواد عمل ایپ کی ملکیت ہے
• قرآن و حدیث عوامی ڈومین میں ہیں
• ایپ کا ڈیزائن اور ٹریڈ مارک محفوظ ہیں
• مواد کاپی یا دوبارہ شائع کرنا منع ہے
• ذاتی استعمال کے لیے ڈاؤن لوڈ کی اجازت ہے
• تجارتی استعمال کے لیے اجازت ضروری ہے`
    },
    {
      icon: <RefreshCw size={28} />,
      title: 'تبدیلیاں اور اختتام',
      content: `شرائط میں تبدیلی کے حوالے سے:

• ہم کسی بھی وقت شرائط میں تبدیلی کر سکتے ہیں
• تبدیلیوں کی اطلاع ایپ میں دی جائے گی
• تبدیلیوں کے بعد استعمال جاری رکھنا قبولیت ہے
• ہم کسی بھی وقت سروس بند کر سکتے ہیں
• شرائط کی خلاف ورزی پر اکاؤنٹ بند ہو سکتا ہے
• ختم ہونے والے حصے مؤثر رہیں گے`
    }
  ];

  return (
    <div className="terms-page">
      {/* Hero Section */}
      <div className="page-hero">
        <div className="container">
          <div className="hero-icon">
            <FileText size={48} />
          </div>
          <h1>شرائط و ضوابط</h1>
          <p>عمل ایپ استعمال کرنے کے لیے شرائط و ضوابط</p>
          <div className="last-updated">
            آخری تازہ کاری: دسمبر 2024
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="page-content">
        <div className="container">
          <div className="intro-text">
            <p>
              یہ شرائط و ضوابط ("شرائط") عمل ایپ ("سروس") کے استعمال پر لاگو ہوتے ہیں۔ براہ کرم ان شرائط کو غور سے پڑھیں۔ ایپ استعمال کرنے سے آپ ان تمام شرائط سے اتفاق کرتے ہیں۔
            </p>
          </div>

          <div className="policy-sections">
            {sections.map((section, index) => (
              <div className="policy-section" key={index}>
                <div className="section-header">
                  <div className="section-icon">
                    {section.icon}
                  </div>
                  <h2>{section.title}</h2>
                </div>
                <div className="section-content">
                  {section.content.split('\n').map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Additional Terms */}
          <div className="additional-terms">
            <h3>اہم نوٹ</h3>
            <p>
              عمل ایپ کا مقصد صارفین کو اسلامی عبادات اور تعلیمات سے جوڑنا ہے۔ ہم اس بات کی پوری کوشش کرتے ہیں کہ تمام مواد درست اور معتبر ہو۔ تاہم، کسی بھی دینی مسئلے میں براہ کرم علماء کرام سے رجوع کریں۔
            </p>
          </div>

          <div className="contact-box">
            <h3>سوالات؟</h3>
            <p>اگر آپ کے شرائط و ضوابط کے بارے میں کوئی سوالات ہیں تو براہ کرم ہم سے رابطہ کریں۔</p>
            <a href="mailto:legal@amalapp.xyz" className="contact-email">
              info@amalapp.xyz
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
